module.exports = __webpack_public_path__ + "img/ethan.4d82f012.png";